import Swal from 'sweetalert2'

import crud from './_crud'
import { clientLogin } from './app'
import { callApi } from '../../utils/api'
import { showSuccessMessage, showErrorMessage } from '../../utils/messages'
import translations from '../../utils/translations'

const entity = 'client'
const actions = crud(entity, 'el cliente', 'los clientes')

function showSuccessMessageRedirect(message, props = {}) {
	Swal.fire({
		icon: 'success',
		text: message,
		showCancelButton: false,
		confirmButtonText: 'Ok',
		allowOutsideClick: false,
		...props,
	}).then((result) => {
		if (result.isConfirmed) {
			setTimeout(() => {
				console.log('Redirigiendo al usuario a /login')
				window.location.href = '/login'
			}, 1000)
		}
	})
}

const updateSync = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/${entity}/utils/update_sync`, {
			method: 'PATCH',
			body: JSON.stringify(item),
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: `Se actualizó el cliente correctamente.`,
		})

		dispatch({
			type: `UPDATE_SYNC_${entity.toUpperCase()}`,
			response: res.body,
		})
	}
}

const addSync = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/${entity}/utils/add_sync`, {
			method: 'POST',
			body: JSON.stringify(item),
			headers: {
				Authorization: state.app.user.token,
			},
			params: {
				will_create_user: item.will_create_user,
			},
			successMessage: `Se agregó el cliente correctamente.`,
		})

		dispatch({
			type: `ADD_SYNC_${entity.toUpperCase()}`,
			response: res.body,
		})
	}
}

export const registerClient = (obj) => {
	return async (dispatch, getState) => {
		let isClosed = false

		try {
			const res = await callApi('/client/create_client', {
				method: 'POST',
				body: JSON.stringify({ client: obj }),
				successMessage: 'Se ha registrado correctamente'
			})

			if (res.status === 200) {
				await dispatch(clientLogin({
					user: obj?.email ?? obj?.cellphone, 
					password: obj?.password
				}))

				const query = (document.URL.indexOf('?') != -1) ? ('?'+document.URL.split('?')[1]) : ''

				setTimeout(() => {
					window.location.href = '/client/company_qr_scanning' + query
				}, 2000)
			}
		} catch (e) {
			console.log(e)
		}
	}
}

export const externalLoginClient = (client, platform) => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi('/client/external_login_client', {
				method: 'POST',
				body: JSON.stringify({ external_client: client, platform, secretWord: 'geodev-ruf' }),
			})

			if (res.status === 200) {
				// localStorage.setItem('@external_token', JSON.stringify({ platform, token: res.body.token  }))
				localStorage.setItem('@client_token', res.body.token)
				dispatch({
					type: 'LOGIN_CLIENT',
					payload: res.body,
				})
			}
		} catch (error) {
		}
	}
}

export const createExclusiveClientForCompany = (sys_company_id, clientData) => {
  return async (dispatch, getState) => {
    const state = getState()

    try {
      const res = await callApi(
        `/client/create_client_for_company/${sys_company_id}`,
        {
          method: 'POST',
          body: JSON.stringify(clientData),
          headers: {
            Authorization: state?.app?.user?.token,
          },
          successMessage: 'Cliente creado correctamente.',
        }
      )

      return res.body
    } catch (error) {
      console.error('Error al crear cliente exclusivo:', error)
      throw error
    }
  }
}

export const updateExclusiveClientForCompany = (
  sys_company_id,
  client_id,
  updateData
) => {
  return async (dispatch, getState) => {
    const state = getState()

    try {
      const res = await callApi(
        `/client/update_exclusive_client_for_company/${sys_company_id}/${client_id}`,
        {
          method: 'PUT',
          body: JSON.stringify(updateData),
          headers: {
            Authorization: state.app.user.token,
          },
          successMessage: 'Cliente actualizado correctamente.',
        }
      )

      return res.body
    } catch (error) {
      console.error('Error al actualizar cliente exclusivo:', error)
      throw error
    }
  }
}

export const deleteExclusiveClient = (clientId) => {
  return async (dispatch, getState) => {
    const state = getState()

    try {
      const res = await callApi(`/client/delete_exclusive_client/${clientId}`, {
        method: 'DELETE',
        headers: {
          Authorization: state.app.user.token,
        },
        successMessage: 'Cliente eliminado correctamente.',
      })


      return res.body
    } catch (error) {
      console.error('Error al eliminar cliente exclusivo:', error)
      throw error
    }
  }
}


export const excelLayoutExclusiveClients = (options = {}) => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/client/generate_exclusive_clients_layout_excel`, {
      method: 'PUT',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify(options?.body || {}),
    })
      .then((res) => {
        let buff = Buffer.from(res.body)
        return buff
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `exclusive_clients_layout.xlsx`)
        document.body.appendChild(link)
        link.click()
        link.parentNode.removeChild(link)
      })

    return res
  }
}

// 2) Importar archivo Excel (parse + validate inicial)
export const importFileExclusiveClients = (options) => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/client/import_exclusive_clients_from_excel`, {
      method: 'PUT',
      json: false,
      headers: {
        Authorization: state.app.user.token,
      },
      body: {
        file: options.files,
      },
    })

    // si tu Exceltable depende del reducer IMPORT, lo dejas.
    // si NO lo quieres, lo puedes quitar (pero tú lo tienes así en categorías)
    dispatch({
      type: 'IMPORT',
      payload: res.body,
    })

    return res.body
  }
}

// 3) Verificar data ya cargada (validación desde JSON)
export const verifyImportDataExclusiveClients = (options) => {
  return async (dispatch, getState) => {
    const state = getState()
	console.log("preres:", "s")
    const res = await callApi(`/client/validate_exclusive_clients_from_import`, {
      method: 'PUT',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify(options.data),
    })
	console.log("res:", res);

    dispatch({
      type: 'IMPORT',
      payload: res.body,
    })

    return res.body
  }
}

// 4) Guardar / bulk create (crea clientes exclusivos + relación)
export const bulkCreateExclusiveClients = (options) => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/client/import_exclusive_clients`, {
      method: 'POST',
      headers: {
        Authorization: state.app.user.token,
      },
      body: JSON.stringify({
        options, // igual que categorías
      }),
      successMessage: `Se registraron los clientes correctamente.`,
    })

    showSuccessMessage('Se registraron los clientes correctamente.')
    return res.body
  }
}



export const getClientsOnDateRange = ({ range, from = null, to = null }) => {
  return async (dispatch, getState) => {
    const state = getState()

	const { superAdmin } = state?.app

	try {
      const params = { range }
	  
      if (range === 'CUSTOM') {
        if (from) params.from = from
        if (to) params.to = to
      }

	  const res = await callApi('/client/getClientsOnDateRange', {
        method: 'GET',
        headers: {
			...superAdmin?.headers,
        //   Authorization: state.app?.user?.token,
        },
        params,
        errorMessage: { error: 'Error al obtener la información de clientes por rango.' },
        shouldSkipStatusError: true,
      })

    //   if (res.status === 200 && Array.isArray(res.body?.labels) && Array.isArray(res.body?.data)) {
    //     dispatch({
    //       type: 'LOAD_CLIENTS_CHART_DATA',
    //       payload: {
    //         labels: res.body.labels,
    //         data: res.body.data,
    //         range,
    //       },
    //     })
    //   }

      return res.body
    } catch (e) {
      console.error('Error al cargar clientes por rango:', e)
    }
  }
}

export const getClientsByCreationDate = ({ from, to }) => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const params = { from, to }

			const res = await callApi('/client/getClientsByCreationDate', {
				method: 'GET',
				params,
				errorMessage: { error: 'Error al obtener la información de clientes por rango.' },
				shouldSkipStatusError: true,
			})

			return res.body
		} catch (e) {
			console.error('Error al cargar clientes por rango:', e)
		}
	}
}

const loadClients = (sys_company_id) => {
	return async (dispatch, getState) => {
		const state = getState()
		try {
			const res = await callApi(`/client/get_clients/${sys_company_id}`, {
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			})

			if (res.status == 200) {
				dispatch({ type: 'LOAD_CLIENTS', response: res.body })
			}
		} catch (e) {
			console.log(e)
		}
	}
}

export const getAmountOfClients = (sys_company_id) => {
	return async (dispatch, getState) => {
		const state = getState()
		const sysCompanyId = sys_company_id ? sys_company_id : state.app?.user?.sys_company_id
		try {
			const res = await callApi(`/client/get_amount_of_clients/${sysCompanyId}`, {
				headers: {
					Authorization: state.app?.user?.token
				},
				errorMessage: {error:'Error al obtener la cantidad de clientes.'},
				shouldSkipStatusError: true,
			})

			if (res.status == 200) {
				dispatch({
					type: 'LOAD_AMOUNT_OF_CLIENTS',
					payload: typeof res.body?.amountOfClients == 'number' ? res.body?.amountOfClients : 0,
				})
			}

			return res.body
		} catch (e) {
		}
	}
}

export const createSysCompany = (
	sysCompanyData,
	userData,
	tablesAndWaitersData
) => {
	return async (dispatch, getState) => {
		try {
			const response = await callApi(`/app/create_sys_company`, {
				method: 'POST',
				body: JSON.stringify({
					sysCompany: sysCompanyData,
					user: userData,
					tablesAndWaiters: tablesAndWaitersData,
				}),
			})
			if (response.status === 200) {
				showSuccessMessageRedirect('Se ha registrado correctamente')
				setTimeout(() => {
					console.log('Redirigiendo al usuario a /login')
					window.location.href = '/login'
				}, 3000)
			}
		} catch (error) {
			console.error(
				'Ha habido un problema con la operación de grabado: ',
				error
			)
		}
	}
}

export const loadTableInfo = (tableInfo) => {
	return async (dispatch, getState) => {
		const state = getState()
		try {
			const res = await callApi(`/client/load_table_info`, {
				method: 'GET',
				params: tableInfo,
			})

			dispatch({
				type: 'TABLE_INFO',
				payload: res.body,
			})

			return res.body
		} catch (e) {
			console.log(e)
		}
	}
}

const deleteClient = (credentials) => {
	return async (dispatch, getState) => {
		const state = getState()
		try {
			const res = await callApi('/client/delete_client', {
				method: 'DELETE',
				body: JSON.stringify(credentials),
			})

			if (res.status === 200) {
				showSuccessMessage("Cliente eliminado con éxito")
				return res.body
			}
		} catch (e) {
			console.log(e)
		}
	}
}

export const sendNotificationToWaiters = ({ table_id, client_message, stall_id }) => {
	return async (dispatch, getState) => {
	  const state = getState()
	  
	  try {
		const res = await callApi(
		  `/utils/send_notification_to_waiters/${table_id}`,
		  {
			method: "POST",
			headers: {
			  Authorization: state.app?.client?.token,
			},
			body: JSON.stringify({ client_message, stall_id }),
		  }
		)

		if (res.status === 200) {
		  console.log("Se ha registrado correctamente")
		  Swal.fire({
			icon:"success",
			title:"Solicitud enviada ✔️",
			text:"Tu solicitud se envió correctamente."
		  })
	
		  return res.body
		}
	  } catch(e) {
	  }
	}
}

export const notifyNewOrder = (clientId, sysCompanyId) => {
  return async (dispatch, getState) => {
    const state = getState();

    try {
      // Llamar a la API para notificar la llegada del cliente
      const res = await callApi(`/client/notify_new_order`, {
        method: "POST",
        headers: {
          Authorization: state.app?.client?.token, // Asegúrate de que el cliente esté autenticado
        },
        body: JSON.stringify({ clientId, sys_company_id: sysCompanyId }),
      });

      if (res.status === 200) {
        return res.body;
      } else {
        throw new Error(res.error || "Error al enviar la notificación.");
      }
    } catch (error) {
      console.error("Error al notificar la orden del cliente:", error);
    }
  };
};

export const fetchCustomerOrders = (clientId) => async (dispatch, getState) => {
  const state = getState();

  try {
    const response = await callApi(`/client/getCustomerOrders/${clientId}`, {
      method: "GET",
    });

    if (response.status != 200) {
      throw new Error(
        response.error || "Algo salió mal al obtener las órdenes del cliente"
      );
    } else {
      dispatch({
        type: "LOAD_CUSTOMER_ORDERS_SUCCESS",
        payload: response,
      });
    }
  } catch (error) {
    dispatch({
      type: "LOAD_CUSTOMER_ORDERS_FAILURE",
      payload: error.message,
    });
  }
};

export const notifyArrival = (clientId, sysCompanyId) => {
  return async (dispatch, getState) => {
    const state = getState();
    const currentTranslations = translations[state?.app?.lang]

    try {
      // Llamar a la API para notificar la llegada del cliente
      const res = await callApi(`/client/notify_arrival`, {
        method: "POST",
        headers: {
          Authorization: state.app?.client?.token, // Asegúrate de que el cliente esté autenticado
        },
        body: JSON.stringify({ clientId, sys_company_id: sysCompanyId }),
      });

      if (res.status === 200) {
		showSuccessMessage(currentTranslations?.notificationSent)
        // PopupAlert(
        //   "success",
        //   currentTranslations?.notificationSent,
        //   currentTranslations?.weHaveNotifiedCompany,
        // );
        return res.body;
      } else {
        throw new Error(res.error || "Error al enviar la notificación.");
      }
    } catch (error) {
      console.error("Error al notificar la llegada del cliente:", error);
	  showErrorMessage('No se pudo enviar la notificación. Por favor, intenta nuevamente.')
    }
  };
};

let customActions = {}
customActions = { ...customActions, updateSync }
customActions = { ...customActions, addSync }

export default { ...actions, ...customActions, 
	createExclusiveClientForCompany, updateExclusiveClientForCompany,
	loadClients, loadTableInfo, deleteClient, getClientsOnDateRange, getClientsByCreationDate }
